<template>
  <div class="q-pa-md">
    <q-form id="queryForm" :model="queryForm" @submit="query" @reset="reset">
      <div class="row q-gutter-md justify-center">
        <div class="col-md-3 col-11">
          <q-input
            filled
            v-model="queryForm.phoneNumber"
            label="手机号"
            dense
            clearable
          />
        </div>
        <div class="col-md-3 col-11">
          <q-btn label="查询" type="submit" color="primary" />
          <q-btn
            label="重置"
            type="reset"
            color="primary"
            flat
            class="q-ml-sm"
          />
        </div>
      </div>
    </q-form>

    <q-table
      ref="mytable"
      title="用户信息"
      :data="tableData.list"
      :columns="columns"
      row-key="id"
      :pagination.sync="pagination"
      :loading="loading"
      @request="request"
      separator="cell"
      :rows-per-page-options="[10, 20, 50, 0]"
    >
      <template v-slot:top>
        用户信息
        <q-icon name="account_circle" />

        <q-space />

        <q-select
          v-model="visibleColumns"
          multiple
          outlined
          dense
          options-dense
          :display-value="$q.lang.table.columns"
          emit-value
          map-options
          :options="columns"
          option-value="name"
          options-cover
          style="min-width: 150px"
        />
      </template>
      <template v-slot:body-cell-avatarUrl="props">
        <q-td>
          <div class="q-px-md q-gutter-sm" style="text-align: center">
            <q-img
              :src="props.row.avatarUrl"
              spinner-color="white"
              style="height: 45px; max-width: 45px"
            />
          </div>
        </q-td>
      </template>
      <template v-slot:body-cell-opt="props">
        <q-td>
          <div class="q-px-md q-gutter-sm" style="text-align: center">
            <q-btn
              round
              color="primary"
              size="xs"
              icon="business"
              @click="showCompany(props.row)"
            >
              <q-tooltip> 绑定公司 </q-tooltip>
            </q-btn>
            <q-btn
              round
              color="primary"
              size="xs"
              icon="lock_open"
              @click="unbindCompany(props.row)"
            >
              <q-tooltip> 解除绑定 </q-tooltip>
            </q-btn>
          </div>
        </q-td>
      </template>
    </q-table>
    <q-dialog v-model="visible">
      <q-card style="max-height: 60vh; width: 600px; max-width: 80vw">
        <q-card-section>
          <div class="text-h6">绑定公司</div>
        </q-card-section>

        <q-separator />

        <q-card-section class="scroll" style="max-height: 60vh">
          <div class="q-gutter-y-md column">
            <q-select
              outlined
              v-model="userRow.companyId"
              :options="customerList"
              option-label="customerName"
              option-value="id"
              emit-value
              map-options
              label="公司名称"
              dense
              clearable
            >
              <template v-slot:prepend>
                <q-icon name="business" />
              </template>
            </q-select>
          </div>
        </q-card-section>

        <q-separator />

        <q-card-actions align="right">
          <q-btn flat label="取消" color="primary" @click="cancel" />
          <q-btn flat label="绑定" color="primary" @click="bindCompany" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { list, bindCompany, unbindCompany } from "@/api/mp/user";
import { listAll } from "@/api/erp/customer";
export default {
  data() {
    return {
      visible: false,
      userRow: {},
      customerList: [],
      queryForm: {},
      tableData: {},
      loading: false,
      pagination: {
        sortBy: "",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      },
      columns: [
        {
          name: "openId",
          align: "center",
          label: "openId",
          field: "openId",
        },
        {
          name: "nickName",
          align: "center",
          label: "用户昵称",
          field: "nickName",
        },
        {
          name: "avatarUrl",
          align: "center",
          label: "用户头像",
          field: "avatarUrl",
        },
        {
          name: "phoneNumber",
          align: "center",
          label: "手机号",
          field: "phoneNumber",
        },
        {
          name: "company",
          align: "center",
          label: "公司",
          field: (row) => (row.customer ? row.customer.customerName : ""),
        },
        {
          name: "LAST_LOGIN",
          align: "center",
          label: "最后登陆时间",
          field: "lastLogin",
          sortable: true,
        },
        {
          name: "opt",
          align: "center",
          label: "操作",
          field: "opt",
        },
      ],
      visibleColumns: [
        "openId",
        "nickName",
        "avatarUrl",
        "phoneNumber",
        "company",
        "lastLogin",
        "opt",
      ],
    };
  },
  methods: {
    listCustomer() {
      var self = this;
      listAll().then((response) => {
        self.customerList = response.data.data;
      });
    },
    query() {
      this.$refs.mytable.requestServerInteraction();
    },
    reset() {
      this.queryForm = {};
      this.pagination = {
        sortBy: "",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      };
      this.query();
    },
    request(props) {
      this.loading = true;
      const { page, rowsPerPage, sortBy, descending } = props.pagination;
      var self = this;
      self.queryForm.pageNum = page;
      self.queryForm.pageSize = rowsPerPage;
      if (sortBy) {
        self.queryForm.orderBy = sortBy + (descending ? " desc" : " asc");
      }else{
        self.queryForm.orderBy = null;
      }
      list(self.queryForm).then(function (response) {
        self.tableData = response.data.data;
        self.pagination.rowsNumber = self.tableData.total;
        // don't forget to update local pagination object
        self.pagination.page = page;
        self.pagination.rowsPerPage = rowsPerPage;
        self.pagination.sortBy = sortBy;
        self.pagination.descending = descending;
        // ...and turn of loading indicator
        self.loading = false;
      });
    },
    showCompany(row) {
      this.userRow = JSON.parse(JSON.stringify(row));
      this.visible = true;
    },
    bindCompany() {
      bindCompany(this.userRow).then(() => {
        this.$q.notify({ type: "positive", message: "绑定成功" });
        this.visible = false;
        this.query();
      });
    },
    unbindCompany(row) {
      this.$confirm("确定要解除绑定公司吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          unbindCompany(row).then(() => {
            this.$q.notify({ type: "positive", message: "解绑成功" });
            this.visible = false;
            this.query();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    cancel() {
      this.visible = false;
    },
  },
  mounted() {
    this.query();
    this.listCustomer();
  },
};
</script>

<style scoped>
#queryForm {
  margin: 50px 0;
}
</style>